'use strict';

angular.module('AdminSystemOwnerReviewControllers', [
    'ngAnimate',
    'ui.bootstrap',
    'mgcrea.ngStrap',
    'angularMoment',
    'pascalprecht.translate',
    'services.systemOwnerReview'
]);

